window.cookieconsent.initialise({
  "palette": {
    "popup": {
      "background": "#ffffff",
      "text": "#0a0a0a"
    },
    "button": {
      "background": "#1779ba"
    }
  },
  "theme": "classic",
  "content": {
    "message": "This website uses cookies to store your website preferences and for web analytics, all analytics data is anonymised.",
    "link": "Learn more about cookies.",
    "dismiss": "I accept"
  }
});



  
jQuery('.off-canvas-wrapper').on('opened.zf.offcanvas', function() {
  jQuery('.hamburger').addClass('is-active');
});
jQuery('.off-canvas-wrapper').on('closed.zf.offcanvas', function() {
  jQuery('.hamburger').removeClass('is-active');
});


//Start contact form
jQuery(function() {
  jQuery("#contact form").on("formvalid.zf.abide", function(ev,frm) {
    jQuery('.ajax-spinner').show();
    var dataString = jQuery("#contact form").serialize();
    jQuery.ajax({
      type: "POST",
      url: "/wp-content/themes/JointsWP/contact.php",
      data: dataString,
      beforeSend: function() {
        jQuery(".form-submit").prop('disabled', true);
      },
      success: function() {
        jQuery('.ajax-spinner').hide();
        jQuery('.contact-submitted').removeClass('hidden');
        jQuery(".form-submit").prop('disabled', false);
      },
      error: function() {
        jQuery('.ajax-spinner').hide();
        jQuery('.contact-error').removeClass('hidden');
      }
    });
  });
  jQuery("#contact form").on("submit", function(ev) {
    ev.preventDefault();
  });
});
//End contact form
